import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
// import InboxIcon from "@material-ui/icons/MoveToInbox";
// import MailIcon from "@material-ui/icons/Mail";
import ListSubheader from "@material-ui/core/ListSubheader";
// import { Link } from "react-router-dom";
//Icons
import LocalHospitalIcon from "@material-ui/icons/LocalHospital";
// import DriveEtaIcon from "@material-ui/icons/DriveEta";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import HistoryIcon from "@material-ui/icons/History";
import HomeIcon from "@material-ui/icons/Home";
// import ErrorIcon from "@material-ui/icons/Error";
import LiveHelpIcon from "@material-ui/icons/LiveHelp";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";
import InfoIcon from "@material-ui/icons/Info";
import PeopleIcon from "@material-ui/icons/People";
import IconButton from "@material-ui/core/IconButton";
import logo from "./taxis.png";
import { Link as RouterLink } from "react-router-dom";
//Home

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginLeft: 0,
      zIndex: theme.zIndex.appBar,
    },
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerContainer: {
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
  },
  brand: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    padding: theme.spacing(1.5, 2),
  },
  brandLink: {
    display: "inline-flex",
    borderRadius: theme.shape.borderRadius,
    "&:focus-visible": {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 4,
    },
  },
  brandLogo: {
    display: "block",
    width: 72,
    height: 72,
    objectFit: "contain",
  },
  closeMenu: {
    position: "absolute",
    top: theme.spacing(1),
    right: theme.spacing(1),
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
}));

export default function ClippedDrawer({ contexto }) {
  const classes = useStyles();
  // At tablet widths the permanent drawer leaves too little room for the page.
  // Keep this breakpoint aligned with the layouts that switch at `down("sm")`.
  const isCompact = useMediaQuery("(max-width: 959.95px)");
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((open) => !open);
  };

  const renderMenu = (index, text) => {
    if (index === 0) {
      return (
        <ListItem button key={text} component={RouterLink} to="/" onClick={() => setMobileOpen(false)}>
          <ListItemIcon>
            <HomeIcon />
          </ListItemIcon>
          <ListItemText primary={text} />
        </ListItem>
      );
    } else if (index === 1) {
      return (
        <ListItem button key={text} component={RouterLink} to="/servicios-solicitados" onClick={() => setMobileOpen(false)}>
          <ListItemIcon>
            <HistoryIcon />
          </ListItemIcon>
          <ListItemText primary={text} />
        </ListItem>
      );
    } else if (index === 2) {
      return (
        <ListItem button key={text} component={RouterLink} to="/quejas" onClick={() => setMobileOpen(false)}>
          <ListItemIcon>
            <LiveHelpIcon />
          </ListItemIcon>
          <ListItemText primary={text} />
        </ListItem>
      );
    } else if (index === 3) {
      return (
        <ListItem button key={text} component={RouterLink} to="/acerca-de" onClick={() => setMobileOpen(false)}>
          <ListItemIcon>
            <InfoIcon />
          </ListItemIcon>
          <ListItemText primary={text} />
        </ListItem>
      );
    }
  };

  const renderServicios = (text) => {
    if (text === "Diálisis") {
      return (
        <ListItem button key={text} component={RouterLink} to="/dialisis" onClick={() => setMobileOpen(false)}>
          <ListItemIcon>
            <LocalHospitalIcon />
          </ListItemIcon>
          <ListItemText primary={text} />
        </ListItem>
      );
    } else if (text === "Radioterapia") {
      return (
        <ListItem button key={text} component={RouterLink} to="/radioterapia" onClick={() => setMobileOpen(false)}>
          <ListItemIcon>
            <LocalHospitalIcon />
          </ListItemIcon>
          <ListItemText primary={text} />
        </ListItem>
      );
    } else if (text === "Quimioterapia") {
      return (
        <ListItem button key={text} component={RouterLink} to="/quimioterapia" onClick={() => setMobileOpen(false)}>
          <ListItemIcon>
            <LocalHospitalIcon />
          </ListItemIcon>
          <ListItemText primary={text} />
        </ListItem>
      );
    } else if (text === "Mutuas") {
      return (
        <ListItem button key={text} component={RouterLink} to="/mutuas" onClick={() => setMobileOpen(false)}>
          <ListItemIcon>
            <LocalHospitalIcon />
          </ListItemIcon>
          <ListItemText primary={text} />
        </ListItem>
      );
    }
  };

  const signOut = () => {
    localStorage.removeItem("idCliente");
    localStorage.removeItem("email");
    localStorage.removeItem("password");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("perfil");
    localStorage.removeItem("csrfToken");
    sessionStorage.removeItem("accessToken");
    window.location.reload();
  };

  const opciones = ["Diálisis", "Radioterapia", "Quimioterapia", "Mutuas"];
  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          {isCompact && (
            <IconButton
              color="inherit"
              edge="start"
              aria-label="Abrir menú de navegación"
              aria-expanded={mobileOpen}
              onClick={handleDrawerToggle}
            >
              <MenuIcon />
            </IconButton>
          )}
          {isCompact && (
            <Typography variant="h6" noWrap>
              APATAXI Lleida
            </Typography>
          )}
          <Typography
            variant="h6"
            noWrap
            style={{ display: isCompact ? "none" : undefined }}
          >
            ASSOCIACIÓ PROVINCIAL D'AUTO TAXIS - LLEIDA
          </Typography>
        </Toolbar>
      </AppBar>
      <Drawer
        variant={isCompact ? "temporary" : "permanent"}
        open={!isCompact || mobileOpen}
        onClose={() => setMobileOpen(false)}
        classes={{
          paper: classes.drawerPaper,
        }}
        ModalProps={{ keepMounted: true }}
      >
        <div className={classes.brand}>
          <RouterLink
            to="/"
            className={classes.brandLink}
            aria-label="Ir al inicio de APATAXI Lleida"
            onClick={() => setMobileOpen(false)}
          >
            <img
              src={logo}
              alt="APATAXI Lleida"
              width={72}
              height={72}
              className={classes.brandLogo}
            />
          </RouterLink>
          {isCompact && (
            <IconButton
              className={classes.closeMenu}
              aria-label="Cerrar menú de navegación"
              onClick={() => setMobileOpen(false)}
            >
              <CloseIcon />
            </IconButton>
          )}
        </div>
        <Divider />
        <div className={classes.drawerContainer}>
          <List
            disablePadding
            aria-label="Navegación principal"
            component="nav"
          >
            {[
              "Home",
              "Servicios solicitados",
              "Quejas",
              "Acerca de",
            ].map(
              (text, index) => renderMenu(index, text)
            )}
            <ListItem button component={RouterLink} to="/pacientes" onClick={() => setMobileOpen(false)}>
              <ListItemIcon><PeopleIcon /></ListItemIcon><ListItemText primary="Pacientes" />
            </ListItem>
          </List>
          <Divider />
          <List
            subheader={
              <ListSubheader component="div" id="nested-list-subheader">
                Solicitud de servicios
              </ListSubheader>
            }
            component="nav"
          >
            {/* {[
              "Diálisis",
              "Radioterapia",
              "Quimioterapia",
              "Mutuas",

              {
                /* "Servicio de taxi", */
            /* }, */
            /* ].map((text, index) => renderServicios(text))} */}
            <div>
              {opciones.filter((text, index) => contexto.serviciosPermitidos.includes(["dialisis", "radioterapia", "quimioterapia", "mutuas"][index])).map((text) => renderServicios(text))}
            </div>
          </List>
          <Divider />
          {/* <List component="nav">
            <ListItem
              button
              key={"Contácta a Vigsoft"}
              component="a"
              href="mailto:ferrantclk@gmail.com"
            >
              <ListItemIcon>
                <InfoIcon />
              </ListItemIcon>
              <ListItemText primary={"Contácta a Vigsoft"} />
            </ListItem>
          </List> */}
          {/* <Divider /> */}
          <List>
            {["Cerrar sesión"].map((text, index) => (
              <ListItem button key={text} onClick={() => signOut()}>
                <ListItemIcon>
                  <ExitToAppIcon></ExitToAppIcon>
                </ListItemIcon>
                <ListItemText primary={text} />
              </ListItem>
            ))}
          </List>
        </div>
      </Drawer>
    </div>
  );
}
